/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminDto } from "../models/AdminDto";
import type { AdminLogAction } from "../models/AdminLogAction";
import type { AdminMeDto } from "../models/AdminMeDto";
import type { AdminWithPermissionsDto } from "../models/AdminWithPermissionsDto";
import type { ChangePasswordDto } from "../models/ChangePasswordDto";
import type { CreateAdminDto } from "../models/CreateAdminDto";
import type { UpdateAdminDto } from "../models/UpdateAdminDto";
import type { UpdateAdminPermissionsDto } from "../models/UpdateAdminPermissionsDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class AdminsService {
  /**
   * 내 정보 조회
   * @returns AdminMeDto
   * @throws ApiError
   */
  public static findMe(): CancelablePromise<AdminMeDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admins/me",
    });
  }
  /**
   * 내 권한 목록 조회
   * 현재 로그인한 관리자의 권한 목록을 조회합니다. 메뉴 활성화 체크에 사용됩니다.
   * @returns string
   * @throws ApiError
   */
  public static findMyPermissions(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admins/me/permissions",
    });
  }
  /**
   * 내 비밀번호 변경
   * @returns any
   * @throws ApiError
   */
  public static changeMyPassword({
    requestBody,
  }: {
    requestBody: ChangePasswordDto;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/admins/me/password",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * 관리자 활동 로그 목록 조회
   * @returns any
   * @throws ApiError
   */
  public static findLogs({
    page = 1,
    itemsPerPage = 30,
    adminId,
    action,
    entityName,
    startDate,
    endDate,
  }: {
    page?: number;
    itemsPerPage?: number;
    /**
     * 관리자 ID
     */
    adminId?: number;
    /**
     * 액션 타입
     */
    action?: AdminLogAction;
    /**
     * 엔티티 이름
     */
    entityName?: string;
    /**
     * 시작 날짜
     */
    startDate?: string;
    /**
     * 종료 날짜
     */
    endDate?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admins/logs",
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
        adminId: adminId,
        action: action,
        entityName: entityName,
        startDate: startDate,
        endDate: endDate,
      },
    });
  }
  /**
   * 로그에 기록된 엔티티 이름 목록
   * @returns string
   * @throws ApiError
   */
  public static getEntityNames(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admins/logs/entity-names",
    });
  }
  /**
   * 관리자 목록 조회
   * @returns AdminDto
   * @throws ApiError
   */
  public static findAllAdmins(): CancelablePromise<Array<AdminDto>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admins",
    });
  }
  /**
   * 관리자 생성
   * @returns AdminDto
   * @throws ApiError
   */
  public static createAdmin({
    requestBody,
  }: {
    requestBody: CreateAdminDto;
  }): CancelablePromise<AdminDto> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admins",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * 관리자 상세 조회
   * @returns AdminDto
   * @throws ApiError
   */
  public static findAdminById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AdminDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admins/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * 관리자 정보 수정
   * @returns AdminDto
   * @throws ApiError
   */
  public static updateAdmin({
    id,
    requestBody,
  }: {
    id: number;
    requestBody: UpdateAdminDto;
  }): CancelablePromise<AdminDto> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/admins/{id}",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * 관리자 삭제
   * @returns any
   * @throws ApiError
   */
  public static deleteAdmin({ id }: { id: number }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admins/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * 관리자 권한 수정
   * @returns AdminWithPermissionsDto
   * @throws ApiError
   */
  public static updatePermissions({
    id,
    requestBody,
  }: {
    id: number;
    requestBody: UpdateAdminPermissionsDto;
  }): CancelablePromise<AdminWithPermissionsDto> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admins/{id}/permissions",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * 관리자의 현재 권한 목록 조회
   * @returns string
   * @throws ApiError
   */
  public static getAdminPermissions({
    id,
  }: {
    id: number;
  }): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admins/{id}/permissions",
      path: {
        id: id,
      },
    });
  }
  /**
   * 전체 권한 목록 조회
   * @returns string
   * @throws ApiError
   */
  public static getAllPermissions(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/permissions",
    });
  }
  /**
   * Role별 기본 권한 목록 조회
   * @returns any
   * @throws ApiError
   */
  public static getPermissionsByRole(): CancelablePromise<Record<string, any>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/permissions/by-role",
    });
  }
}
